import { render } from "./DTdetails.vue?vue&type=template&id=62da1df4&scoped=true"
import script from "./DTdetails.vue?vue&type=script&lang=js"
export * from "./DTdetails.vue?vue&type=script&lang=js"

import "./DTdetails.vue?vue&type=style&index=0&id=62da1df4&lang=scss&scoped=true"
import "./DTdetails.vue?vue&type=style&index=1&id=62da1df4&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62da1df4"]])

export default __exports__